import { createSelector, createStructuredSelector } from 'reselect'
import { EMPTY_STR, identity } from '@lacele/const'
import { makeQueryString } from '@lacele/utils'
import { createGetState } from '../../Redux/selector'
import { getStatus, getData } from './reducer'
import {
    STATUS_FETCH,
    STATUS_UNAUTHORIZED
} from '../const'
import defaultFetchService from '../fetchService'
import { userInfo } from '../../../App/selector'

export const mapStateToProps = () => {

    const fetchService = createSelector(
        (_, props) => props.fetchService,
        (fetchServiceProp) => fetchServiceProp || defaultFetchService
    )

    // TODO provare
    const xAuthToken = createSelector(
        identity,
        (state) => userInfo.getXAuthToken(state)
    )

    const getQueryString = createSelector(
        (_, props) => props.query,
        (query$) => (query$ ? makeQueryString(query$) : EMPTY_STR)
    )

    const getUrlWithQueryString = createSelector(
        (_, props) => props.url,
        getQueryString,
        (url, queryString) => url + queryString
    )

    const getFetchStatus = createSelector(
        createGetState(),
        getStatus
    )

    const canFetch = createSelector(
        xAuthToken,
        (_, props) => props.disable,
        getFetchStatus,
        (token, disable, fetchStatus) => !disable && (
            // (disable, fetchStatus) => !disable && (
            (fetchStatus === STATUS_FETCH)
            || (fetchStatus === STATUS_UNAUTHORIZED && token)
        )
    )

    const query = () => null

    const includeResponse = () => true

    return createStructuredSelector({
        fetchService,
        xAuthToken,
        canFetch,
        data: getData,
        url: getUrlWithQueryString,
        query,
        includeResponse
    })
}
